// Determina a URL base da API
const getApiBaseUrl = () => {
  // Em desenvolvimento, usa proxy configurado no craco.config.js
  if (process.env.NODE_ENV === "development") {
    return "/api";
  }

  // Em produção, usa window.REACT_APP_BACKEND_URL (injetado pelo entrypoint.sh)
  const envUrl = window.REACT_APP_BACKEND_URL;

  // Se envUrl está vazio ou é undefined, usa URL relativa para produção
  if (!envUrl || envUrl === "") {
    return "/api";
  }

  // Se a URL já termina com /api, usa como está
  if (envUrl.endsWith("/api")) {
    return envUrl;
  }

  // Se a URL não tem /api, adiciona
  return envUrl + "/api";
};

export { getApiBaseUrl };
